import moduleAbilities from "@/composables/moduleAbilities";
import abilities from "@/composables/abilities";

export default {
    /*
    |--------------------------------------------------------------------------
    | RH Routes
    |--------------------------------------------------------------------------|
    */

    path: 'access',
    name: 'access',
    children: [
        {
            name: "access-cards",
            path: "cards",
            component: () => import('@/Modules/Access/views/Cards/Index.vue'),
            meta: {requiresPermission: abilities.CAN_CARD_CONFIG_VIEW},
        },
        {
            name: "access-historics",
            path: "historics",
            component: () => import('@/Modules/Access/views/Historics/Index.vue'),
            meta: {requiresPermission: abilities.CAN_VIEW_ACCESS_HISTORICS},
        },
        {
            name: "access-configs",
            path: "configurations",
            component: () => import('@/Modules/Access/views/Config/Index.vue'),
            meta: {requiresPermission: abilities.CAN_VIEW_ACCESS_CONFIG},
        },

        {
            name: 'access-card-history',
            path: '/card/history/:id',
            component: () => import('@/Modules/Access/views/Cards/CardHistory.vue'),
            meta: {requiresPermission: abilities.CAN_CARD_CONFIG_HISTORIC_VIEW},
        },
        {
            path: 'settings-system',
            name: 'access-settings-system',
            component: () => import('@/Modules/Access/views/Setting/Layouts/BaseSystemSetting.vue'),
            children: [
                {
                    name: "access-settings-perimeter-types",
                    path: "perimeter-type",
                    component: () => import('@/Modules/Access/views/Setting/PerimeterTypes/Index.vue'),
                    meta: {requiresPermission: abilities.CAN_VIEW_PERIMETER},
                },
                {
                    name: "access-settings-perimeters",
                    path: "perimeters",
                    component: () => import('@/Modules/Access/views/Setting/Perimeters/Index.vue'),
                    meta: {requiresPermission: abilities.CAN_VIEW_PERIMETER},
                },
                {
                    name: "access-settings-doors",
                    path: "doors",
                    component: () => import('@/Modules/Access/views/Setting/Doors/Index.vue'),
                    meta: {requiresPermission: abilities.CAN_VIEW_DOOR},
                },
                {
                    name: "access-settings-configurations",
                    path: "configurations",
                    component: () => import('@/Modules/Access/views/Setting/Configurations/Index.vue'),
                    meta: {requiresPermission: abilities.CAN_VIEW_ACCESS_CONFIG},
                },
            ]
        },
    ]

}
